export default {
  assistant: {
    title: 'flexiAI',
    subtitle: 'Operations copilot',
    close: 'Close',
    newChat: 'New conversation',
    emptyHint: 'Ask about routes, trips, delays, riders or reservations. Every answer comes from live data, with your own permissions.',
    inputPlaceholder: 'Ask about today’s operation…',
    thinking: 'Looking into it…',
    toolRunning: 'Checking {name}…',
    toolFailed: '{name} failed',
    sessionExpired: 'Your Flexigo session has expired. Sign in again to keep using the assistant.',
    reload: 'Sign in again',
    busy: 'Still working on your previous question — one moment.',
    dailyLimit: 'You have reached today’s assistant limit. It resets at midnight.',
    disabled: 'The assistant is currently turned off.',
    unavailable: 'The assistant is unreachable right now. Try again in a moment.',
    errorGeneric: 'Something went wrong. Please try again.',
    disclaimer: 'flexiAI can make mistakes — verify critical details before acting.',
    prompts: {
      late: 'Which routes are late right now?',
      today: 'How is today’s operation going overall?',
      live: 'Show the live status of a route',
      history: 'Has a route been late repeatedly in the last two weeks?',
      approvals: 'Is anything waiting for my approval?',
      tickets: 'What have riders complained about on a route?',
      stops: 'List a route’s stops in order',
      rider: 'Which route is a rider assigned to?',
    },
  },
};
